import { Component, OnInit } from '@angular/core';
import {TagService} from '../../services/tag-service.service';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {UserService} from '../../services/user.service';
import {Tag} from '../../admin/tag/model/tag';
import {User} from '../../admin/user/model/user';

@HostListener('window:keydown', ['$event'])
@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  },
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
})

export class FeedbackComponent implements OnInit {
  public hex = require("../../../assets/hex.jpg");
  public model = new Tag('', '', '', '');
  theUser: string;
  theHashTag: string;
  sub: any;


  constructor(private userService: UserService, private tagService: TagService, private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router)//, private _cookieService:CookieService) 
  {
  }

  ngOnInit() { 
    this.theUser = this.userSVC.authUser.email;
    if (!this.theUser) {
      this.router.navigate(['']);
    }
  }

  submitTag(){
    let commentOperation:Observable<Tag[]>;
    var tb1 = document.getElementById("subject");
    var tb2 = document.getElementById("value");
    if (tb1.innerText === "" || tb2.innerText === "")
    {
      alert("Both the values can not be empty")
      return;
    }

    this.model.source = this.theUser;
    this.model.email =  "feedback@tagndoc.com";
    this.model.hashTag = "feedback";
    this.model.value = "<subject>" + tb1.innerText + "</subject>" +  tb2.innerText;
    this.tagService.addTag(this.model).subscribe(
      () => {
        this.router.navigate(['/admin/account']);
      },  
      err => {
        console.log(err);
      }); 
  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 13:
        this.submitTag()
        event.preventDefault();
        break;
    }
    return;
  }
}




// WEBPACK FOOTER //
// ./src/app/admin/feedback/feedback.component.ts